import { z } from 'zod';

// TODO move out of commons
export enum ValidationEntrySeverity {
    FATAL = 'FATAL',
    CRITICAL = 'CRITICAL',
    WARNING = 'WARNING',
    NOTE = 'NOTE',
}

export const ValidationEntrySeveritySchema = z.enum(
    ValidationEntrySeverity
);

export const validationEntrySeverityIndex: Record<
    ValidationEntrySeverity,
    number
> = {
    [ValidationEntrySeverity.NOTE]: 1,
    [ValidationEntrySeverity.WARNING]: 2,
    [ValidationEntrySeverity.CRITICAL]: 3,
    [ValidationEntrySeverity.FATAL]: 4,
};
